import { gql } from '../types/generated';

export const VALIDATE_LITMUS_SCHEMA = gql(`
  mutation validateLitmusSchema($validationProcess: String!, $gamePk: Int!) {
    validate(validationProcess: $validationProcess, gamePk: $gamePk) {
      isValid
      validationProcess
      ruleResults {
        name
        description
        result
      }
    }
  }
`);
